import { render, staticRenderFns } from "./locationMange.vue?vue&type=template&id=62fae7ce"
import script from "./locationMange.vue?vue&type=script&lang=js"
export * from "./locationMange.vue?vue&type=script&lang=js"
import style0 from "./locationMange.vue?vue&type=style&index=0&id=62fae7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports